import { createStore } from 'vuex'
import auth from './auth'
import register from './register'
import practice from './practice'
import doctor from './doctor'
import doctorReasons from './doctorReasons'
import users from './users'
import patientsD4W from './patientsD4W'
import version from './version'
import app_books from './app_books'

export default createStore({
  state: {
    serverVersion: null,
    clientVersion: '1.0.18',
    userId: null,
    userData: null,
    userIsAdmin: false,
    lastResponse: null,
    patientsList: [],
    practiceList: [],
    doctorList: [],
    doctorsReasonsList: [],
    appbooksList: [],
    // appointments
    appointmentDateTime: undefined,
    //--- admin data
    usersList:[],
    patientsD4WList: [],
  },
  getters: {
    getClientVersion: state => state.clientVersion,
    getServerVersion: state => state.serverVersion,
    getLastResponse: state => state.lastResponse,
    // пациенты
    getPatientList: state => state.patientsList.map(e => {
      return {...e, selected: false}
    }),
    getPatientInfo: (state, patientId) => state.patientsList.find((e, i, a) => e.patient_id == patientId),
    // пользователи
    getUserId: state => state.userId,
    getUserData: state => state.userData,
    getIsAdmin: state => state.userIsAdmin,
    getUserName: state => state.userData ? state.userData.firstname : 'Пользователь',
    getFullUserName: state => state.userData ? (`${state.userData.surname} ${state.userData.firstname} ${state.userData.middlename}`) : 'Пользователь',
    getUserMiddleName: state => state.userData ? state.userData.middlename : '',
    getUserData: state => state.userData,
    // практики
    getPracticeList: state => state.practiceList.map(e => {
      return {...e, selected: false}
    }),
    // врачи
    getDoctorList: state => state.doctorList.map(e => {
      return {...e, selected: false}
    }),
    getDoctorsReasonsList: state => state.doctorsReasonsList,
    getAppBooksList: state => state.appbooksList.map(e => {
      return {...e, selected: false}
    }),
    getPracticeInfo: (state, practiceId) => state.practiceList.find((e, i, a) => e.practice_id == practiceId),
    // состояния авторизации
    getLoginViewTitle: (state) => state.loginViewTitle,
    getAfterLoginRoute: (state) =>  state.afterLoginRoute,
    // appointments
    getAppointmentDateTime: (state) => state.appointmentDateTime,
    // связка пользователь-пациенты
    getUsersList: (state) => state.usersList.map(e => {
      return {
        id: e.id,
        surname: e.surname,
        name: e.firstname,
        middlename: e.middlename,
        phone: e.phone,
        email: e.email,
        bindedPatients: e.bindedPatients,
        patientsLoadError: e.patientsLoadError,
      };
    }),
    getpatientsD4WList: (state) => state.patientsD4WList.map(e => {
      return {
        id: e.patient_id,
        surname: e.surname,
        name: e.firstname,
        middlename: e.middlename,
        dob: e.dob,
        sex: e.patient_sex,
        phone_mobile: e.mobile,
        phone_home: e.phone_home,
        email: e.email,
      };
    }),
  },
  mutations: {
    setUserId: (state, userId) => {
      state.userId = userId;
    },
    saveResponse: (state, data) => {
      state.lastResponse = data;
    },
    setUserData: (state, data) => {
      state.userData = data;
    },
    setAppointmentDateTime: (state, datetime) => {
      state.appointmentDateTime = datetime;
    },
    setUserIsAdmin: (state, admin) => {
      state.userIsAdmin = admin;
    },
    setUserPatientsList: (state, data) => {
      state.patientsList =  data;
    }
  },
  actions: {

  },
  modules: {
    auth, register, practice, doctor, users, patientsD4W, version, app_books, doctorReasons
  }
})
